import contentTable from '@/components/common/more-tab-content/content-table/index.vue';

export default {
    name: 'cpwsgk',
    data() {
        return {
            crumbsList: Object.freeze([{
                name: '裁判文书公开',
                key: 'cpwsgk'
            }]),
            gjfyLinkList: [
                {
                    name: '上海',
                    url: 'http://www.hshfy.sh.cn/shfy/web/cpws.jsp'
                },
                {
                    name: '江苏',
                    url: 'http://47.110.239.193/jsfyssfw/pages/cpws.html?type=cpws'
                },
                {
                    name: '广东',
                    url: 'http://www.gdcourts.gov.cn/index.php?m=openness&f=index&v=ws_index'
                },
                {
                    name: '海南',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '湖北',
                    url: 'http://www.hbfy.gov.cn/WenshuManage/getWenshuByFolder?folderNo=0906'
                },
                {
                    name: '辽宁',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '广西',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '福建',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '浙江',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '山东',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '天津',
                    url: 'https://wenshu.court.gov.cn/'
                }
            ],
            hsfyLinkList: [
                {
                    name: '上海',
                    url: 'https://shhsfy.gov.cn/hsfyytwx/hsfyytwx/cpws1359/yxcpws1521/index.html?tm=1629882333095'
                },
                {
                    name: '南京',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '广州',
                    url: 'http://www.gzhsfy.gov.cn/hsmh/front/wsxxList?fjm=JM0&wslx=qbcpws'
                },
                {
                    name: '海口',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '武汉',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '大连',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '北海',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '厦门',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '宁波',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '青岛',
                    url: 'https://wenshu.court.gov.cn/'
                },
                {
                    name: '天津',
                    url: 'https://wenshu.court.gov.cn/'
                }
            ],
            // 高级人民法院的选项
            gjrmfyList: [
                {
                    name: '上海',
                    suffix: '高级',
                    code: 'sh-gjfy'
                },
                {
                    name: '江苏',
                    suffix: '高级',
                    code: 'js-gjfy'
                },
                {
                    name: '广东',
                    suffix: '高级',
                    code: 'gd-gjfy'
                },
                {
                    name: '海南',
                    suffix: '高级',
                    code: 'hn-gjfy'
                },
                {
                    name: '湖北',
                    suffix: '高级',
                    code: 'hb-gjfy'
                },
                {
                    name: '辽宁',
                    suffix: '高级',
                    code: 'll-gjfy'
                },
                {
                    name: '广西',
                    suffix: '高级',
                    code: 'gx-gjfy'
                },
                {
                    name: '福建',
                    suffix: '高级',
                    code: 'fj-gjfy'
                },
                {
                    name: '浙江',
                    suffix: '高级',
                    code: 'zj-gjfy'
                },
                {
                    name: '山东',
                    suffix: '高级',
                    code: 'sd-gjfy'
                },
                {
                    name: '天津',
                    suffix: '高级',
                    code: 'tj-gjfy'
                }
            ],
            // 海事法院的选项
            hsfyList: [
                {
                    name: '上海',
                    suffix: '海事',
                    code: 'sh-hsfy'
                },
                {
                    name: '南京',
                    suffix: '海事',
                    code: 'nj-hsfy'
                },
                {
                    name: '广州',
                    suffix: '海事',
                    code: 'gz-hsfy'
                },
                {
                    name: '海口',
                    suffix: '海事',
                    code: 'hk-hsfy'
                },
                {
                    name: '武汉',
                    suffix: '海事',
                    code: 'wh-hsfy'
                },
                {
                    name: '大连',
                    suffix: '海事',
                    code: 'dl-hsfy'
                },
                {
                    name: '北海',
                    suffix: '海事',
                    code: 'bh-hsfy'
                },
                {
                    name: '厦门',
                    suffix: '海事',
                    code: 'xm-hsfy'
                },
                {
                    name: '宁波',
                    suffix: '海事',
                    code: 'nb-hsfy'
                },
                {
                    name: '青岛',
                    suffix: '海事',
                    code: 'qd-hsfy'
                },
                {
                    name: '天津',
                    suffix: '海事',
                    code: 'tj-hsfy'
                }
            ],
            active: null,
            zgrmfyList: [
                {
                    name: '最高',
                    suffix: '',
                    code: 'gz-zgrmfy'
                }
            ],
            // 精品裁判文书索结果
            jpcpwsData: [],
            // 不上网文书检索结果
            bawwsData: [],
            // 分页参数
            pageParam: {
                total: 100,
                offset: 0,
                limit: 10
            }
        };
    },
    components: {contentTable},
    mounted() {
        this.initCpwsData();
        this.initBswwsqdData({name: '', suffix: ''});
    },
    methods: {
        // 精品裁判文书
        initCpwsData() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.home.latestJpcpws,
                params: {offset: 0, limit: 3}
            })
                .then((res) => {
                    if (res.data) {
                        this.jpcpwsData = res.data.data;
                    }
                })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        },
        // 不上网文书清单
        initBswwsqdData(item) {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.home.latestBswwsqd,
                params: {
                    offset: this.pageParam.offset,
                    limit: this.pageParam.limit,
                    fbdw: item.name,
                    suffix: item.suffix
                }
            })
                .then((res) => {
                    if (res.data) {
                        this.bawwsData = res.data.data;
                        this.pageParam.total = res.data.total;
                    }
                })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        },
        goToHsal() {
            this.$router.push({path: '/hsal'});
        },
        // 打开外链
        handleOpenLink(item) {
            window.open(item.url);
        },
        changeActive(item) {
            this.active = item;
            if (item === null) {
                this.initBswwsqdData({name: '', suffix: ''});
            } else {
                this.initBswwsqdData(item);
            }
        },
        // 截取信息加'...'
        getMsg(msg) {
            const strLength = 145;
            return msg.length > strLength ? `${msg.substring(0, strLength)}...` : msg;
        },
        // 点击跳转详情
        handleToDetail(item) {
            const url = this.$router.resolve({path: '/xwzxDetail', query: {active:'index', bh:item.bh, fileType: 22}});
            window.open(url.href, '_blank');
        },
        // 跳转到海事案例的详情页面
        openCpws(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active: 'hsal', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        pageInformation(pageInfo) {
            this.pageParam.limit = pageInfo.limit;
            this.pageParam.offset = pageInfo.offset;
            if (this.active) {
                this.initBswwsqdData(this.active);
            } else {
                this.initBswwsqdData({name: '', suffix: ''});
            }
        }
    }
};
